import _ from 'lodash';
import Service from './abstract';

const defaultWith = 'type,status';
const defaultOptionsFind = {
    order: 'created_at-DESC',
    with: defaultWith
};

class Reports extends Service {
    constructor () {
        super('reports');
    }

    get defaultOptionsFind () {
        return _.merge({}, super.defaultOptionsFind, defaultOptionsFind);
    }

    createReport (data = {}, options = {}) {
        return this.post({
            url: `${this.basePath}/reports`,
            data,
            ...options
        });
    }

    getOne (id) {
        return this.get({
            url: `${this.basePath}/reports/${id}`
        });
    }
}

export default new Reports();
